module.exports = __webpack_public_path__ + "User Samples Requests.8644537af2d35b9c3e28.png";